import comp from '../components/barrel';
import svg from '../js/svg';
import listReturnState from '../js/listReturnState';

const EP = 'advisors/get-leads';
const MARKETERS_EP = 'communal/marketers';
const USER_EP = 'users/get-user-details';
const PAGE_SIZE = 50;

function cellText(val) {
  return val != null && String(val).trim() !== '' ? String(val) : '';
}

function ynText(val) {
  if (val === true) return 'Yes';
  if (val === false) return 'No';
  return '—';
}

async function dateText(val) {
  if (val == null || String(val).trim() === '') return '—';
  return await U.formatDate(val);
}

export default {
  async prepare() {
    this.vars = this.vars || {};
    const listRestore = this.vars.listRestore;
    if (listRestore) {
      this.vars.selected_page = listRestore.selected_page || 1;
      this.vars.keyword = listRestore.keyword || '';
      this.vars.marketer_uuid = listRestore.marketer_uuid || '';
      this.vars.activeYN_yes = !!listRestore.activeYN_yes;
      this.vars.activeYN_no = !!listRestore.activeYN_no;
    } else {
      this.vars.selected_page = 1;
    }
    if (!this.vars.activeYN_yes && !this.vars.activeYN_no) {
      this.vars.activeYN_yes = true;
      this.vars.activeYN_no = false;
    }
    const {value: loggedInUuid} = await O.getCookie('ewttgpvwwkf');
    this.recipe.methods.push(await O.mPOST(EP, this.buildRequestVars(this.vars.selected_page)));
    this.recipe.methods.push(await O.mPOST(MARKETERS_EP, {}));
    if (loggedInUuid) {
      this.recipe.methods.push(await O.mPOST(USER_EP, {target_user_uuid: loggedInUuid}));
    }
  },

  buildRequestVars(page) {
    const vars = {
      page: page || 1,
      limit: PAGE_SIZE,
      activeYN_yes: !!this.vars.activeYN_yes,
      activeYN_no: !!this.vars.activeYN_no,
    };
    const keyword = this.vars.keyword ? String(this.vars.keyword).trim() : '';
    if (keyword) vars.keyword = keyword;
    if (!this.isMarketerRole() && this.vars.marketer_uuid) vars.marketer_uuid = this.vars.marketer_uuid;
    return vars;
  },

  isMarketerRole() {
    return (this.loggedInRoleText || '').trim().toLowerCase() === 'marketer';
  },

  marketerSourceText(uuid) {
    const id = cellText(uuid);
    if (!id) return '—';
    const match = (this.marketersData || []).find((row) => String(row.user_uuid) === id);
    return match ? match.fullName : id;
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) data = await O.PREP(rec);
    const userDetails = data[USER_EP]?.data;
    this.loggedInRoleText = userDetails?.role_text || null;
    const marketersRes = data[MARKETERS_EP] || {};
    this.marketersData = Array.isArray(marketersRes.data)
      ? marketersRes.data.map((row) => ({
          ...row,
          fullName: `${cellText(row.f_name)} ${cellText(row.s_name)}`.trim() || cellText(row.user_uuid),
        }))
      : [];
    await this.loadPage(data);
  },

  async loadPage(data) {
    const restore = this.vars && this.vars.listRestore;
    if (restore) {
      this.vars.keyword = restore.keyword || '';
      this.vars.marketer_uuid = restore.marketer_uuid || '';
      this.vars.activeYN_yes = !!restore.activeYN_yes;
      this.vars.activeYN_no = !!restore.activeYN_no;
    }
    setTimeout(() => this.syncFiltersFromVars(), 0);

    const clearBtn = U.id('clearLeadFilters');
    if (clearBtn) {
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.vars.keyword = '';
        this.vars.marketer_uuid = '';
        this.vars.activeYN_yes = true;
        this.vars.activeYN_no = false;
        this.vars.selected_page = 1;
        this.syncFiltersFromVars();
        this.getLeadList();
      });
    }
    const onActive = () => {
      const yes = U.id('activeYesCheckbox');
      const no = U.id('activeNoCheckbox');
      this.vars.activeYN_yes = !!(yes && yes.checked);
      this.vars.activeYN_no = !!(no && no.checked);
      this.vars.selected_page = 1;
      this.getLeadList();
    };
    const yesBox = U.id('activeYesCheckbox');
    const noBox = U.id('activeNoCheckbox');
    if (yesBox) yesBox.addEventListener('change', onActive);
    if (noBox) noBox.addEventListener('change', onActive);

    const search = U.id('leadKeywordSearch');
    const clearKw = U.id('leadKeywordClear');
    if (search) {
      search.addEventListener('input', () => {
        if (clearKw) clearKw.hidden = !search.value;
        clearTimeout(this.keywordTimer);
        this.keywordTimer = setTimeout(() => {
          this.vars.keyword = search.value;
          this.vars.selected_page = 1;
          this.getLeadList();
        }, 350);
      });
    }
    if (clearKw && search) {
      clearKw.addEventListener('click', () => {
        search.value = '';
        clearKw.hidden = true;
        this.vars.keyword = '';
        this.vars.selected_page = 1;
        this.getLeadList();
      });
    }

    await this.buildTableHead();
    const listData = data[EP] || {};
    await this.buildTableBody(Array.isArray(listData.data) ? listData.data : []);
    const paginationState = listData.pagination || {
      total_count: 0,
      page_size: PAGE_SIZE,
      current_page: 1,
      total_pages: 0,
    };
    this.vars.selected_page = paginationState.current_page || 1;
    await this.buildPaginationButtons(paginationState);
  },

  syncFiltersFromVars() {
    const search = U.id('leadKeywordSearch');
    const clearKw = U.id('leadKeywordClear');
    if (search) search.value = this.vars.keyword || '';
    if (clearKw) clearKw.hidden = !search || !search.value;
    const yes = U.id('activeYesCheckbox');
    const no = U.id('activeNoCheckbox');
    if (yes) yes.checked = !!this.vars.activeYN_yes;
    if (no) no.checked = !!this.vars.activeYN_no;
    const marketerDD = U.id('leadMarketerFilter');
    if (marketerDD) marketerDD.value = this.vars.marketer_uuid || '';
  },

  onMarketerChange() {
    const marketerDD = U.id('leadMarketerFilter');
    this.vars.marketer_uuid = marketerDD ? String(marketerDD.value || '').trim() : '';
    this.vars.selected_page = 1;
    this.getLeadList();
  },

  async buildTableHead() {
    const tableHead = U.id('leadTableHead');
    if (!tableHead) return;
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();
    const labels = ['', 'Type', 'Name', 'Email', 'Cell', 'Last contact', 'Follow up', 'Active', 'Retired', 'Marketer source', 'Source', 'Social media'];
    labels.forEach((label, i) => {
      headRow.insertCell(i).innerHTML = label;
    });
    const marketer = headRow.insertCell(labels.length);
    if (!this.isMarketerRole() && this.marketersData && this.marketersData.length) {
      const marketerDD = await comp.selectThead(
        'leadMarketerFilter',
        this.marketersData,
        'user_uuid',
        'fullName',
        'thsPage.onMarketerChange()',
        'Select marketer'
      );
      marketer.appendChild(marketerDD);
      const el = U.id('leadMarketerFilter');
      if (el && this.vars.marketer_uuid) el.value = this.vars.marketer_uuid;
    } else {
      marketer.innerHTML = 'Marketer';
    }
  },

  async buildTableBody(rows) {
    const tbody = U.id('leadTableBody');
    if (!tbody) return;
    tbody.innerHTML = '';
    if (!rows.length) {
      const tr = tbody.insertRow();
      const cell = tr.insertCell(0);
      cell.colSpan = 13;
      cell.textContent = 'No leads found.';
      return;
    }
    for (const row of rows) {
      const tr = tbody.insertRow();
      const view = tr.insertCell(0);
      view.className = 'advisor-icon-cell';
      const linkSVG = svg.linkNewPage();
      linkSVG.style.cursor = 'pointer';
      linkSVG.setAttribute('role', 'button');
      linkSVG.setAttribute('title', 'View lead');
      linkSVG.addEventListener('click', (e) => {
        e.preventDefault();
        listReturnState.save('ViewLead', {
          listPage: 'ManageLeads',
          state: {
            selected_page: this.vars.selected_page || 1,
            keyword: this.vars.keyword || '',
            marketer_uuid: this.vars.marketer_uuid || '',
            activeYN_yes: !!this.vars.activeYN_yes,
            activeYN_no: !!this.vars.activeYN_no,
          },
        });
        O.PREP('ViewLead', `lead_uuid=${row.lead_uuid}`);
      });
      view.appendChild(linkSVG);
      tr.insertCell(1).textContent = row.lead_type === 'organisation' ? 'Organisation' : 'Independent advisor';
      tr.insertCell(2).textContent = cellText(row.display_name) || '—';
      tr.insertCell(3).textContent = cellText(row.primary_email) || '—';
      tr.insertCell(4).textContent = cellText(row.primary_cell) || '—';
      tr.insertCell(5).textContent = await dateText(row.last_contact_report);
      tr.insertCell(6).textContent = await dateText(row.crm_follow_up);
      tr.insertCell(7).textContent = ynText(row.active_yn);
      tr.insertCell(8).textContent = ynText(row.retired_yn);
      tr.insertCell(9).textContent = this.marketerSourceText(row.marketersource);
      tr.insertCell(10).textContent = cellText(row.source) || '—';
      tr.insertCell(11).textContent = cellText(row.social_media) || '—';
      tr.insertCell(12).textContent = `${cellText(row.marketer_f_name)} ${cellText(row.marketer_s_name)}`.trim() || '—';
    }
  },

  async getLeadList() {
    const res = await O.PREP([await O.mPOST(EP, this.buildRequestVars(this.vars.selected_page || 1))]);
    const listData = res[EP] || {};
    await this.buildTableBody(Array.isArray(listData.data) ? listData.data : []);
    const paginationState = listData.pagination || {total_count: 0, total_pages: 0, current_page: 1};
    this.vars.selected_page = paginationState.current_page || 1;
    await this.buildPaginationButtons(paginationState);
  },

  async buildPaginationButtons(paginationState) {
    const totalPages = paginationState.total_pages || 0;
    const wrapper = U.id('leadPaginationWrapper');
    if (totalPages > 0) {
      await comp.paginationButtons({totalPages, wrapperID: 'leadPaginationWrapper'});
      document.querySelectorAll('#leadPaginationWrapper .pageButton').forEach((button) => {
        button.addEventListener('click', (e) => {
          thsPage.vars.selected_page = Number(e.target.getAttribute('value'));
          thsPage.getLeadList();
        });
      });
    } else if (wrapper) {
      wrapper.innerHTML = '';
    }
    const total = paginationState.total_count != null ? paginationState.total_count : 0;
    const pages = paginationState.total_pages || 0;
    ['totalRecordsDisplay', 'totalRecordsDisplayBottom'].forEach((id) => {
      const el = U.id(id);
      if (el) el.textContent = String(total);
    });
    ['totalPagesDisplay', 'totalPagesDisplayBottom'].forEach((id) => {
      const el = U.id(id);
      if (el) el.textContent = String(pages);
    });
  },
};
